import React from "react";

import { Helmet } from "react-helmet";
import Breadcrumb from "../../Component/Breadcrumb";
import { useAuth } from "../../Store/AuthContext";

export default function Disclaimer() {
  const { webSetting, Pagemetatags } = useAuth();
  return (
    <>
      <Helmet>
        <title>{Pagemetatags.disclaimer_title}</title>
        <meta
          name="description"
          content={Pagemetatags.disclaimer_description}
        />
        <meta name="keywords" content={Pagemetatags.disclaimer_keyword} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      <Breadcrumb pagename={"Disclaimer"} mainpage="" />

      <section className="service-details-section section-padding pt-3">
        <div className="container">
          <div className="service-details-wrapper">
            <div className="row g-4">
              <div className="col-lg-1"></div>
              <div className="col-lg-10">
                <div
                  className="gt-details-content"
                  dangerouslySetInnerHTML={{
                    __html: webSetting.disclaimer,
                  }}
                ></div>
              </div>
              <div className="col-lg-1"></div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
